var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 284.109,
    height: 141.541,
    viewBox: "0 0 284.109 141.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -5.321,
    y1: 1,
    x2: -5.321,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-65.43 -88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_street_food_hm5i",
    transform: "translate(65.423 88.01)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 135.891,
    cy: 38.827,
    rx: 135.891,
    ry: 38.827,
    transform: "translate(12.334 63.876)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M961.812,370.83a13.083,13.083,0,0,1,2.386,13.607c-3.092,8.129,5.3,21.649,5.3,21.649l-.257-.042a15.948,15.948,0,0,1-10.586-24.413C960.983,378.074,962.892,373.9,961.812,370.83Z",
    transform: "translate(-713.559 -322.4)",
    fill: "#5964ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M973.23,370.83s3.1,6.716,0,12.194-.53,20.854,7.687,23.062",
    transform: "translate(-724.977 -322.4)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M941.88,449.206s6.251-1,6.82,4.606,12.022,6.378,12.022,6.378l-.214.144c-9.455,6.206-18.493,3.949-17.13-4.287C943.888,452.983,943.84,449.905,941.88,449.206Z",
    transform: "translate(-703.384 -378.619)",
    fill: "#5964ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M941.88,449.206s6.251-1,6.82,4.606,12.022,6.378,12.022,6.378l-.214.144c-9.455,6.206-18.493,3.949-17.13-4.287C943.888,452.983,943.84,449.905,941.88,449.206Z",
    transform: "translate(-703.384 -378.619)",
    fill: "#f5f5f5",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M941.88,449.38s4.852,1.066,4.454,5.478,7.207,9.7,14.386,5.509",
    transform: "translate(-703.384 -378.793)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M317.167,307.7l-13.5-1H126.14v-26H317.167Z",
    transform: "translate(-90.555 -201.53)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M186.321,214.321H174.66v-6.866a4.8,4.8,0,0,1,4.8-4.8h2.07a4.8,4.8,0,0,1,4.8,4.8Z",
    transform: "translate(-152.575 -201.666)",
    fill: "#ededf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M360.9,310.757V350.43l-13.02-.169c0-.282.02-.564.02-.829a25.668,25.668,0,1,0-51.337,0c0,.056,0,.113,0,.166l-13-.169H216.218a25.673,25.673,0,0,0-.158-2.821c-.048-.451-.107-.894-.183-1.334a25.222,25.222,0,0,0-.773-3.345c-.135-.451-.282-.894-.446-1.334a25.829,25.829,0,0,0-1.5-3.334c-.243-.454-.5-.9-.773-1.334a25.718,25.718,0,0,0-2.457-3.334q-.6-.691-1.244-1.334a25.668,25.668,0,0,0-36.272,0q-.646.646-1.244,1.334a25.721,25.721,0,0,0-2.457,3.334c-.282.437-.53.88-.773,1.334a25.833,25.833,0,0,0-1.5,3.334c-.161.44-.31.883-.446,1.334a25.214,25.214,0,0,0-.773,3.334c-.076.44-.135.883-.183,1.334a25.665,25.665,0,0,0-.158,2.821H139.21V261.75H320.241L338.2,300.91l22.32,9.681Z",
    transform: "translate(-127.124 -244.088)",
    fill: "#5964ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M46.82,33.09H216.8a7.052,7.052,0,0,1,7.052,7.052v1.283H42.82V37.087A4,4,0,0,1,46.82,33.09Z",
    transform: "translate(-30.737 -23.763)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M531.56,208.437H490.22V206.88A7.78,7.78,0,0,1,498,199.1h23.891Z",
    transform: "translate(-379.124 -199.11)",
    fill: "#ededf4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 23.336,
    height: 16.002,
    rx: 8.001,
    transform: "translate(8.416 92.337)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M504.776,149.729H485.44V62.05h38v60.674Z",
    transform: "translate(-348.507 -44.555)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 23.336,
    height: 16.002,
    rx: 8.001,
    transform: "translate(8.083 93.006)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 12.668,
    height: 18.67,
    rx: 6.334,
    transform: "translate(226.779 91.672)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 12.668,
    height: 18.67,
    rx: 6.334,
    transform: "translate(227.445 92.005)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 40.339,
    height: 35.671,
    transform: "translate(72.257 30.163)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M256.15,153.282l29-21.5,4,1L256.15,156.616Z",
    transform: "translate(-183.893 -94.616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M256.15,134.434,271.819,117.6l7.334,1.667-23,21.669Z",
    transform: "translate(-183.893 -84.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 28.004,
    height: 38.672,
    rx: 14.002,
    transform: "translate(142.434 23.997)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 3.667,
    height: 8.002,
    transform: "translate(165.104 66)",
    fill: "#1a2246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M740.78,299.74v27.615a1.557,1.557,0,0,0,1.557,1.557h16.995a1.557,1.557,0,0,0,1.326-2.372l-16.995-27.615a1.557,1.557,0,0,0-2.883.815Z",
    transform: "translate(-559.008 -270.246)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M650.042,117.6l-5.641,7.83v3l7.489-7.833Z",
    transform: "translate(-462.628 -84.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M654.456,145.36,644.4,153.949v2.417l12.31-8Z",
    transform: "translate(-462.628 -104.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 18.002,
    cy: 18.002,
    r: 18.002,
    transform: "translate(45.421 87.339)",
    fill: "#1a2246"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 10.002,
    cy: 10.002,
    r: 10.002,
    transform: "translate(53.421 95.339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2.668,
    cy: 2.668,
    r: 2.668,
    transform: "translate(60.588 102.506)",
    fill: "#1a2246"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 18.002,
    cy: 18.002,
    r: 18.002,
    transform: "translate(177.106 87.339)",
    fill: "#1a2246"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 10.002,
    cy: 10.002,
    r: 10.002,
    transform: "translate(185.106 95.339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 2.668,
    cy: 2.668,
    r: 2.668,
    transform: "translate(192.606 102.506)",
    fill: "#1a2246"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 125.017,
    height: 1.334,
    transform: "translate(11.917 77.836)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M674.983,277.3H617.81l.666-1v-.333h56.507",
    transform: "translate(-443.539 -198.134)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M676.677,257.214H620.17V255.88h56.507",
    transform: "translate(-445.233 -183.711)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M676.677,237.121H620.17V235.79h56.124",
    transform: "translate(-445.233 -169.288)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M178.379,491.63a25.566,25.566,0,0,0-2.288,1.334H138.61V491.63Z",
    transform: "translate(-126.693 -409.126)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M424.6,491.63v1.334H365.118a25.567,25.567,0,0,0-2.288-1.334Z",
    transform: "translate(-287.667 -409.126)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M171.982,508.18q-.646.646-1.244,1.334H138.61V508.18Z",
    transform: "translate(-126.693 -421.007)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M440.883,508.18v1.334H386.754q-.6-.691-1.244-1.334Z",
    transform: "translate(-303.95 -421.007)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M168.281,524.72c-.282.437-.53.88-.773,1.334h-28.9V524.72Z",
    transform: "translate(-126.693 -432.882)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M450.3,524.72v1.334H399.4c-.243-.454-.5-.9-.773-1.334Z",
    transform: "translate(-313.369 -432.882)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M216.916,541.27c-.161.44-.31.883-.446,1.334h-6.95V541.27Z",
    transform: "translate(-177.602 -444.764)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M456.089,541.27V542.6H407.136c-.135-.451-.282-.894-.446-1.334Z",
    transform: "translate(-319.156 -444.764)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M215.695,557.82c-.076.44-.135.883-.183,1.334H209.52V557.82Z",
    transform: "translate(-177.602 -456.645)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M459.191,557.82v1.334h-48c-.048-.451-.107-.894-.183-1.334Z",
    transform: "translate(-322.257 -456.645)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 2,
    height: 0.2,
    transform: "translate(107.262 57.51)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 2,
    height: 0.2,
    transform: "translate(110.264 57.51)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M300.08,396.614s4.321-.071,3.974-1.464-3.7-.626-3.7-.626Z",
    transform: "translate(-242.617 -339.259)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M521.54,340.35s3.334,5,5.667.333",
    transform: "translate(-401.61 -300.517)",
    fill: "#5964ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M186.715,101.1H85.37l7.334-16h86.345Z",
    transform: "translate(-61.285 -61.103)",
    fill: "#5964ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M181.16,340.35s3.334,7,12.169,0",
    transform: "translate(-157.241 -300.517)",
    fill: "#5964ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 82.012,
    height: 6,
    transform: "translate(33.752 68.003)",
    fill: "#ededf4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 81.82,
    height: 42.5,
    transform: "translate(34.22 27.503)",
    fill: "#ededf4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 82.012,
    height: 1.001,
    transform: "translate(33.752 70.003)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M987.308,482.276s-3.932-.787-4.979-1.833-5.766-2.883-6.29-1.571-7.077,5.766-2.62,6.553,10.485,1.049,11.793.525S987.308,482.276,987.308,482.276Z",
    transform: "translate(-724.918 -399.639)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M973.437,494.7c4.457.787,10.484,1.049,11.793.525,1-.4,1.692-2.316,1.974-3.21l.13.028s-.787,3.145-2.1,3.667-7.334.262-11.793-.525c-1.286-.226-1.653-.759-1.515-1.436C972.032,494.188,972.48,494.526,973.437,494.7Z",
    transform: "translate(-724.938 -409.399)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M1058.405,468.258s3.726-12.657-.7-21.971a19.99,19.99,0,0,1-1.616-12.541,33.62,33.62,0,0,1,1.774-5.887",
    transform: "translate(-785.11 -363.343)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M1053.57,400.5c0,1.551,2.821,6.048,2.821,6.048s2.821-4.5,2.821-6.048a2.821,2.821,0,0,0-5.616,0Z",
    transform: "translate(-783.569 -341.868)",
    fill: "#5964ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M1035.56,425.833c.846,1.3,5.641,3.551,5.641,3.551s-.088-5.3-.931-6.6a2.821,2.821,0,1,0-4.716,3.052Z",
    transform: "translate(-770.202 -358.612)",
    fill: "#5964ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M1033.31,475.664c1.385.7,6.665.217,6.665.217s-2.753-4.533-4.138-5.232a2.821,2.821,0,1,0-2.539,5.015Z",
    transform: "translate(-767.749 -393.76)",
    fill: "#5964ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M1044.875,516.247c1.247.922,6.533,1.34,6.533,1.34s-1.946-4.933-3.193-5.856a2.821,2.821,0,0,0-3.34,4.513Z",
    transform: "translate(-776.659 -423.269)",
    fill: "#5964ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M1061.976,438.341c-1.111,1.08-6.3,2.2-6.3,2.2s1.269-5.148,2.381-6.228a2.821,2.821,0,1,1,3.915,4.028Z",
    transform: "translate(-785.084 -367.267)",
    fill: "#5964ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M1071.485,483.872c-1.385.7-6.665.217-6.665.217s2.753-4.533,4.138-5.232a2.821,2.821,0,0,1,2.539,5.015Z",
    transform: "translate(-791.646 -399.808)",
    fill: "#5964ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M1075.813,530.8c-1.247.922-6.533,1.34-6.533,1.34s1.946-4.933,3.193-5.856a2.821,2.821,0,0,1,3.34,4.513Z",
    transform: "translate(-794.848 -433.715)",
    fill: "#5964ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M1025.93,549.689s-6.812-1.362-8.629-3.179-9.991-5-10.9-2.725-12.262,9.991-4.541,11.353,18.165,1.817,20.433.908S1025.93,549.689,1025.93,549.689Z",
    transform: "translate(-744.525 -446.004)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M1001.865,571.154c7.72,1.362,18.165,1.817,20.433.908,1.729-.691,2.931-4.014,3.4-5.562l.229.048s-1.362,5.45-3.633,6.358-12.716.454-20.433-.908c-2.228-.392-2.866-1.317-2.626-2.485C999.42,570.288,1000.207,570.872,1001.865,571.154Z",
    transform: "translate(-744.53 -462.877)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M96.6,399.046a2.9,2.9,0,0,0,.773,2.288s2.874,3.785,4.3,5.924c-.082.581-.138.934-.138.934h0v.079h.037l-.037.237h.039a45.242,45.242,0,0,0-1.128,7.176v.3s.333,4.869.344,8.643a12.746,12.746,0,0,1-.344,3.859c-.319.626-.426,3.7-.423,7.19,0,5.06.237,11.133.423,11.867a.756.756,0,0,0,.22.353c-.282,1.128-.821,2.711-1.611,3a1.512,1.512,0,0,0-.984,1.309v.248a.126.126,0,0,0,.02.082v.028a.223.223,0,0,0,.028.079v.025c0,.028.025.054.039.079v.02a.953.953,0,0,0,.141.183h0l.076.068.031.023.071.048.042.025.073.039.051.023.079.031.056.02.087.025.062.017.1.02h.434c2.008,0,3.089-.457,3.706-1.371l1.235-.3v-.034h0v-.316h0l.028-.147v-.009l.014-.082h0c.014-.087.031-.181.048-.282v-.017c.017-.1.031-.209.048-.322h0c.017-.113.031-.228.045-.35v-.014c0-.118.025-.24.037-.364v-.155a1.674,1.674,0,0,1,.017-.237V448.9h.121l1.08-17.074,3.859-15.232,1.85,12.786v2.355c0,3.642.071,10.352.629,11.235a4.131,4.131,0,0,1,.341,1.918,29.029,29.029,0,0,1-.341,3.723h.045c-.028.195-.045.307-.045.307h.141c-.1,1-.13,2.082-.138,2.6h0v.3s2.626.3,3.089.3c2.589,0,5.867,1.219,6.947.457l.093-.073.02-.017.056-.054.014-.017.042-.054v-.014a.433.433,0,0,0,.031-.056h0a.339.339,0,0,0,.017-.059h0a.3.3,0,0,0,0-.062h0a.322.322,0,0,0,0-.065h0c-.149-.539-1.678-1.01-2.75-1.481-.925-.406-1.712-1.96-2.135-2.953a.7.7,0,0,0,.155-.609.719.719,0,0,0-.025-.4c-.564-1.692-.745-15.965-.77-18.163l1.388-9.889a6.432,6.432,0,0,0,.158-1.8,73.456,73.456,0,0,0-.719-8.253h.406l-.051-.3h.051l-.618-3.667v-4.781l.773-8.386.925.609c.071,0,.2-.1.375-.282,1.975.866,4.513,1.974,5.955,2.556,2.626,1.066,2.778,0,2.778,0l5.094-9.909s8.956-3.667,6.022-5.184-7.1,1.523-7.72,3.049a55.172,55.172,0,0,1-4.942,7.317c-.773.914-1.235.3-2.008-.457a21.852,21.852,0,0,0-2.062-1.6l.056-.076a2.308,2.308,0,0,1-.812-.612c-1.224-1.379-3.859-4.152-5.359-4.265-1.87-.141-4.273-2-4.595-2.257a7.28,7.28,0,0,1,.017-1.348h.014a.486.486,0,0,1,.017-.155,4.742,4.742,0,0,0,3.774-4.62,3,3,0,0,0-.014-.355.14.14,0,0,0,.085,0,7.293,7.293,0,0,0,.3-2.186,1.613,1.613,0,0,1,.116-.508c.065-.141.172-.262.234-.406a.824.824,0,0,0,.054-.392,1.879,1.879,0,0,0-.22-.866,15.086,15.086,0,0,0-1.653-3.052,1.013,1.013,0,0,0-.375-.341,1.374,1.374,0,0,0-.539-.059,7.973,7.973,0,0,1-2.44-.674,2.8,2.8,0,0,0-2.448.087c-.694.48-.956,1.43-1.692,1.811-.2.1-.429.155-.629.265a2.423,2.423,0,0,0-.522.671,5.078,5.078,0,0,0-.99,1.628,4.268,4.268,0,0,0-.135,1.267v.426a2.741,2.741,0,0,0,.781,2.316,1.625,1.625,0,0,1,.4.415,1.258,1.258,0,0,1,.186.685c.034.471.22.942.254,1.41a.953.953,0,0,0,.135.511.338.338,0,0,0,.471.09l.028-.119c.051.073.1.147.155.217a8.549,8.549,0,0,1-.9,2.821h-.1a3.534,3.534,0,0,0-2.045.671,22.061,22.061,0,0,1-5.306,2.226,1.633,1.633,0,0,0-.488.959A29.152,29.152,0,0,0,97,388.387h0a11.2,11.2,0,0,0-.454,2.451v.062h.023l-.025.135.547.133C96.667,393.45,96.058,397.54,96.6,399.046Zm3.385-.762a31.84,31.84,0,0,0,1.052-3.08,7.669,7.669,0,0,0,.956,2.166,4.067,4.067,0,0,1,.384,2.223,36.4,36.4,0,0,1-.226,3.65A33.083,33.083,0,0,1,100,398.285Z",
    transform: "translate(-96.38 -318.294)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M158.487,651.982s1.052,3.156,2.4,3.757,3.455,1.2,2.4,1.952-4.231-.451-6.77-.451c-.451,0-3-.3-3-.3s0-4.056.6-4.8S158.487,651.982,158.487,651.982Z",
    transform: "translate(-137.398 -524.093)",
    fill: "#59495d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M107.112,652.53s-.6,3.6-1.8,4.056-1.5,2.4.451,2.4,3-.451,3.6-1.351l1.2-.3s.75-3.455,0-4.358Z",
    transform: "translate(-102.098 -524.64)",
    fill: "#59495d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M158.487,651.982s1.052,3.156,2.4,3.757,3.455,1.2,2.4,1.952-4.231-.451-6.77-.451c-.451,0-3-.3-3-.3s0-4.056.6-4.8S158.487,651.982,158.487,651.982Z",
    transform: "translate(-137.398 -524.093)",
    fill: "#59495d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M107.112,652.53s-.6,3.6-1.8,4.056-1.5,2.4.451,2.4,3-.451,3.6-1.351l1.2-.3s.75-3.455,0-4.358Z",
    transform: "translate(-102.098 -524.64)",
    fill: "#59495d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M173.739,422.581a43.2,43.2,0,0,1,3.6,2.705c.75.753,1.2,1.351,1.952.451a53.438,53.438,0,0,0,4.8-7.213c.59-1.5,4.657-4.513,7.512-3s-5.859,5.108-5.859,5.108l-4.945,9.765s-.15,1.052-2.705,0-8.564-3.752-8.564-3.752Z",
    transform: "translate(-148.892 -354.189)",
    fill: "#f0b9bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M128.329,511.159s1.351,9.308.75,11.119l-1.351,9.765s.15,16.377.75,18.18-5.41,1.955-5.41,1.955.75-4.657,0-5.859-.6-13.373-.6-13.373l-1.811-12.623L116.9,535.346l-1.038,16.831s-4.056-.149-4.358-1.351-.75-16.978,0-18.481,0-12.62,0-12.62.6-8.564,2.4-9.616S128.329,511.159,128.329,511.159Z",
    transform: "translate(-106.938 -422.181)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M128.329,510.082s1.351,9.308.75,11.119l-1.351,9.765s.15,16.377.75,18.18-5.41,1.952-5.41,1.952.75-4.657,0-5.859-.6-13.373-.6-13.373l-1.811-12.62L116.9,534.27,115.862,551.1s-4.056-.149-4.358-1.351-.75-16.978,0-18.481,0-12.62,0-12.62.6-8.564,2.4-9.616S128.329,510.082,128.329,510.082Z",
    transform: "translate(-106.938 -421.406)",
    fill: "#524d64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M130.3,400.06s-.3,7.213-2.855,5.859l2.257,6.77,5.108-.3,3-4.056-2.257-1.351s-1.653.6-.451-4.959Z",
    transform: "translate(-118.681 -343.385)",
    fill: "#f0b9bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M119.147,420.211s2.553,2.1,4.513,2.257c1.464.113,4.028,2.846,5.218,4.206a2.257,2.257,0,0,0,.79.6s-3,4.206-3.455,4.206l-.9-.6-.75,8.265v4.959l.6,3.6s-9.466.15-10.366-.6-6.011.6-6.011.6,1.5-9.765.451-10.967-2.855-9.616-2.855-9.616-1.2-3.455,0-4.513a21.268,21.268,0,0,0,5.162-2.192,3.41,3.41,0,0,1,1.989-.663h.11A2.954,2.954,0,0,0,116,422.465C118.25,422.914,119.678,422.084,119.147,420.211Z",
    transform: "translate(-103.172 -357.528)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M119.147,419.144s2.553,2.1,4.513,2.257c1.464.113,4.028,2.846,5.218,4.206a2.257,2.257,0,0,0,.79.6s-3,4.206-3.455,4.206l-.9-.6-.75,8.265v4.956l.6,3.6s-9.466.15-10.366-.6-6.011.6-6.011.6,1.5-9.765.451-10.967-2.855-9.616-2.855-9.616-1.2-3.455,0-4.513a21.268,21.268,0,0,0,5.162-2.192,3.41,3.41,0,0,1,1.989-.663h.11A2.954,2.954,0,0,0,116,421.4C118.25,421.844,119.678,421.034,119.147,419.144Z",
    transform: "translate(-103.172 -356.76)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M104.013,437.262s-4.513-.6-4.959-.6,1.5-7.362,2.553-8.112,2.4,2.705,2.4,2.705Z",
    transform: "translate(-98.248 -363.761)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(3.212 62.455)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M148.976,420.959c.183,1.343-.773,2.034-2.336,1.96,1.433-.079,2.211-.9,1.8-2.369C148.434,420.553,148.643,420.719,148.976,420.959Z",
    transform: "translate(-135.67 -420.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M176.4,458.38l.685.457a.493.493,0,0,1-.234.144l-.477-.319Z",
    transform: "translate(-157.014 -447.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M107.75,445.07s2.257,8.414,3.306,9.616c.984,1.128-.268,9.743-.432,10.851l-.468.118s1.5-9.765.451-10.967S107.75,445.07,107.75,445.07Z",
    transform: "translate(-107.75 -438.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M135.8,515.322c.629.525,5.41.609,8.256.612-2.759,0-8.045-.062-8.7-.612a1.548,1.548,0,0,0-.877-.223A2.106,2.106,0,0,1,135.8,515.322Z",
    transform: "translate(-126.933 -488.423)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M99.443,452.543s-1.5,7.213-.75,9.308a2.9,2.9,0,0,0,.75,2.257s4.959,6.612,4.959,7.213,1.5,3.455,4.056,1.052c0,0,1.2-1.653-1.5-3S102,461.1,102,461.1s2.257-5.56,1.351-7.362S99.443,452.543,99.443,452.543Z",
    transform: "translate(-97.884 -380.994)",
    fill: "#f0b9bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M8.13,252.826l-5.56-1.351L3.024,249l2.4-.375,3.156,1.049Z",
    transform: "translate(-1.84 -178.499)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M8.13,252.289l-5.56-1.354.454-2.479,2.4-.375,3.156,1.052Z",
    transform: "translate(-1.84 -178.111)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M136.838,400.59l4.8,1.952a21.108,21.108,0,0,0-.384,2.3,4.66,4.66,0,0,1-4.7-1.769A21.832,21.832,0,0,0,136.838,400.59Z",
    transform: "translate(-125.214 -343.765)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 4.657,
    cy: 4.657,
    r: 4.657,
    transform: "translate(10.422 51.716)",
    fill: "#f0b9bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M139.3,374.13a1.607,1.607,0,0,1,.11-.5c.065-.138.169-.26.226-.4a1.394,1.394,0,0,0-.161-1.089,14.928,14.928,0,0,0-1.611-3.007.99.99,0,0,0-.364-.336,1.323,1.323,0,0,0-.525-.059,7.686,7.686,0,0,1-2.372-.663,2.713,2.713,0,0,0-2.383.085c-.691.471-.928,1.41-1.659,1.785-.2.1-.417.152-.612.262a2.373,2.373,0,0,0-.66.646,3.757,3.757,0,0,0-1.092,3.12,2.713,2.713,0,0,0,.759,2.282,1.593,1.593,0,0,1,.389.409,1.252,1.252,0,0,1,.181.674c.034.465.214.928.248,1.393a.948.948,0,0,0,.133.5.327.327,0,0,0,.46.09l.471-1.938a2.643,2.643,0,0,1,.437-1.078c.35-.429.973-.643,1.159-1.168.133-.375.017-.86.31-1.128a.956.956,0,0,1,.432-.186,10.219,10.219,0,0,1,4.121-.127,1.178,1.178,0,0,1,.42.133,1.264,1.264,0,0,1,.446.7c.1.282.463,1.859.846,1.752A7.579,7.579,0,0,0,139.3,374.13Z",
    transform: "translate(-119.202 -320.256)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M139.308,373.59a1.608,1.608,0,0,1,.11-.5c.065-.138.169-.26.226-.4a1.393,1.393,0,0,0-.161-1.089,14.926,14.926,0,0,0-1.611-3.007.99.99,0,0,0-.364-.336,1.323,1.323,0,0,0-.525-.059,7.687,7.687,0,0,1-2.372-.663,2.713,2.713,0,0,0-2.384.085c-.691.471-.928,1.41-1.659,1.785-.2.1-.417.152-.612.262a2.372,2.372,0,0,0-.66.646,3.757,3.757,0,0,0-1.092,3.108,2.713,2.713,0,0,0,.759,2.282,1.594,1.594,0,0,1,.389.409,1.252,1.252,0,0,1,.186.694c.034.465.214.928.248,1.393a.948.948,0,0,0,.133.5.327.327,0,0,0,.465.076l.471-1.938a2.643,2.643,0,0,1,.437-1.077c.35-.429.973-.643,1.159-1.168.133-.375.017-.86.31-1.128a.955.955,0,0,1,.432-.186,10.219,10.219,0,0,1,4.121-.127,1.18,1.18,0,0,1,.42.133,1.264,1.264,0,0,1,.446.7c.1.282.463,1.859.846,1.752A7.936,7.936,0,0,0,139.308,373.59Z",
    transform: "translate(-119.205 -319.869)",
    fill: "#575168"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 0.451,
    cy: 1.052,
    rx: 0.451,
    ry: 1.052,
    transform: "translate(11.547 55.095)",
    fill: "#f0b9bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M156.564,669.356c2.519,0,5.709,1.2,6.77.451a.754.754,0,0,0,.245-.26c.087.178.028.364-.245.564-1.052.75-4.231-.451-6.77-.451-.451,0-3-.3-3-.3v-.3C153.619,669.063,156.118,669.356,156.564,669.356Z",
    transform: "translate(-137.426 -536.508)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M105.731,663.35c1.952,0,3-.451,3.6-1.351l1.2-.3a16.286,16.286,0,0,0,.333-2.677,15.364,15.364,0,0,1-.333,2.979l-1.2.3c-.6.9-1.653,1.351-3.6,1.351-1.089,0-1.478-.609-1.41-1.224C104.4,662.924,104.823,663.35,105.731,663.35Z",
    transform: "translate(-102.071 -529.3)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 5.41,
    height: 2.104,
    transform: "translate(12.047 91.56) rotate(160.92)",
    fill: "#524d64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 5.41,
    height: 2.104,
    transform: "translate(12.047 91.56) rotate(160.92)",
    opacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.495e6d95e8b1d4159970172d0441f93a.svg";
export { ForwardRef as ReactComponent };